import { Form } from 'antd';

const { Item: FormItem } = Form;

export default FormItem;
